"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CognitoErrorCode = void 0;
var CognitoErrorCode;
(function (CognitoErrorCode) {
    CognitoErrorCode.NOT_CONFIRMED = 'UserNotConfirmedException';
    CognitoErrorCode.NOT_AUTHORIZED = 'NotAuthorizedException';
})(CognitoErrorCode = exports.CognitoErrorCode || (exports.CognitoErrorCode = {}));



//////////////////
// WEBPACK FOOTER
// ./src/types/cognito/error_code.ts
// module id = xiZB
// module chunks = 1